import { render, staticRenderFns } from "./SingleTapButton.vue?vue&type=template&id=6150d514&scoped=true"
import script from "./SingleTapButton.vue?vue&type=script&lang=js"
export * from "./SingleTapButton.vue?vue&type=script&lang=js"
import style0 from "./SingleTapButton.vue?vue&type=style&index=0&id=6150d514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6150d514",
  null
  
)

export default component.exports